/**
 * A type representing the modifier keys.
 */
export type ModifierKey = 'alt' | 'ctrl' | 'meta' | 'shift';
